export const MAP_PEOPLE = 'MAP_PEOPLE';
export const MAP_MOBILE_LOCATIONS = 'MAP_MOBILE_LOCATIONS';
export const MAP_TRIPS = 'MAP_TRIPS';
export const ADDRESS = 'ADDRESS';
export const EXPATRIATION = 'EXPATRIATION';
export const ACCESS_POINT = 'ACCESS_POINT';
export const PERSON_MOBILE_LOCATIONS_RADIO = 'personMobileLocationsRadio';
export const PERSON_ORGS = 'personOrgs';
export const INCLUDE_SUB_ORGS = 'includeSubOrganizations';
export const ALL = 'ALL';
export const LAST = 'LAST';
export const SEPARATE_MOBILE_LOCATIONS = 'separateMobileLocations';
export const AIRLINE_ID = 'airlineId'; // DEPRECATED (HZFE_139) - remove when feature toggle is removed
export const AIRLINE_IDS = 'airlineIds';
export const AIRPORT_ID = 'airportId';
export const HOTEL_NAME = 'hotelNameLike';
// DEPRECATED (HZFE_139) - remove the following when feature toggle is removed
export const FLIGHT_NUMBER_LIKE = 'flightNumberLike';
export const FLIGHT_NUMBERS = 'flightNumbers';
export const RAILWAY = 'railwayNameLike';
export const TRAIN_NUMBER = 'trainNumberLike';
export const SITE = 'SITE';
export const OCCUPANT = 'OCCUPANT';
export const POC = 'POC';
